import React from 'react';
import { Form } from 'semantic-ui-react';
import { GenericScaledField } from './GenericScaledField';
import { useSelector } from 'react-redux';

interface LatLngCoordinateInputProps {
  site: any;
  setModified: (modified: boolean) => void;
  disabled: boolean;
  resetValue: any;
  latitudeField?: string; // Optional: defaults to 'latitude'
  longitudeField?: string; // Optional: defaults to 'longitude'
}

export const LatLngCoordinateInput: React.FC<LatLngCoordinateInputProps> = ({
  site,
  setModified,
  disabled,
  resetValue,
  latitudeField = 'latitude',
  longitudeField = 'longitude',
}) => {
  const latLngFormat = useSelector(
    (state: any) => state.mainFrame.prefs.latLngFormat
  );

  return (
    <Form.Group widths="equal">
      <GenericScaledField
        key="latitude"
        label="Latitude"
        required={true}
        alwaysEnabled={false}
        extraProps={{ isLat: true }}
        getter={latitudeField}
        defaultValue={site.latitude}
        setModified={setModified}
        watch={resetValue}
        width={16}
        units={latLngFormat}
        disabled={disabled}
      />
      <GenericScaledField
        key="longitude"
        label="Longitude"
        required={true}
        alwaysEnabled={false}
        getter={longitudeField}
        extraProps={{ isLat: false }}
        defaultValue={site.longitude}
        units={latLngFormat}
        watch={resetValue}
        width={16}
        setModified={setModified}
        disabled={disabled}
      />
    </Form.Group>
  );
};
